export enum BracketType {
    Bracket,
    Rounds,
}